import { forwardRef } from 'react'

export const Tile = forwardRef(({ name, icon }, ref) => {
  const displayToast = (name) => {
    ref.current.style.opacity = '1'
    ref.current.textContent = name
  }
  const hideToast = () => (ref.current.style.opacity = '0')

  return (
    <div
      className='tile'
      onMouseOver={() => displayToast(name)}
      onMouseOut={hideToast}>
      <img src={icon} alt={name} />
    </div>
  )
})
